/**
 * @generated SignedSource<<5af0d996371472ae7f23a3e02bdba53b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type BrandMessageStatusEnum = "A" | "S" | "%future added value";
export type ChatBubbleTypeEnum = "CAROUSEL_COMMERCE" | "CAROUSEL_FEED" | "COMMERCE" | "IMAGE" | "PREMIUM_VIDEO" | "TEXT" | "WIDE" | "WIDE_ITEM_LIST" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BrandMessageTemplateDescriptionList_brandMessageTemplate$data = {
  readonly additionalContent: string | null;
  readonly adult: boolean;
  readonly buttons: ReadonlyArray<{
    readonly linkIos: string | null;
    readonly linkMobile: string | null;
    readonly linkType: string;
    readonly name: string;
  }>;
  readonly carousel: any | null;
  readonly chatBubbleType: ChatBubbleTypeEnum;
  readonly commerce: any | null;
  readonly content: string;
  readonly coupon: {
    readonly description: string;
    readonly linkAndroid: string | null;
    readonly linkIos: string | null;
    readonly linkMobile: string | null;
    readonly linkPc: string | null;
    readonly title: string;
  } | null;
  readonly createTime: any;
  readonly header: string | null;
  readonly id: string;
  readonly imageLink: string | null;
  readonly imageUrl: string | null;
  readonly parameterNames: ReadonlyArray<string>;
  readonly serviceStatus: BrandMessageStatusEnum;
  readonly templateCode: string;
  readonly templateName: string;
  readonly updateTime: any | null;
  readonly video: any | null;
  readonly wideItemList: any | null;
  readonly " $fragmentType": "BrandMessageTemplateDescriptionList_brandMessageTemplate";
};
export type BrandMessageTemplateDescriptionList_brandMessageTemplate$key = {
  readonly " $data"?: BrandMessageTemplateDescriptionList_brandMessageTemplate$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTemplateDescriptionList_brandMessageTemplate">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkMobile",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkIos",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrandMessageTemplateDescriptionList_brandMessageTemplate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updateTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chatBubbleType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parameterNames",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adult",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "header",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "additionalContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "carousel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wideItemList",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "video",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "commerce",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandMessageButton",
      "kind": "LinkedField",
      "name": "buttons",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkType",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandMessageCoupon",
      "kind": "LinkedField",
      "name": "coupon",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkPc",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkAndroid",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "BrandMessageTemplate",
  "abstractKey": null
};
})();

(node as any).hash = "e4a091c84281b77b5ec28f85398b9144";

export default node;
